import React, { lazy, Suspense } from 'react';
import ContentLoader from '../components/shared/ContentLoader';

/**
 * Utility function to lazy load components with a consistent loading UI
 * 
 * @param {Function} importFunc - Import function that returns a promise (e.g., () => import('./Component'))
 * @param {Object} options - Configuration options
 * @param {string} options.loadingMessage - Message to display during loading
 * @param {number} options.minHeight - Minimum height of the loader
 * @param {string} options.size - Size of the loader (small, medium, large)
 * @returns {React.LazyExoticComponent} Lazy loaded component with Suspense fallback
 */
const lazyLoad = (importFunc, options = {}) => {
  const {
    loadingMessage = 'Loading...',
    minHeight = 200,
    size = 'medium'
  } = options;
  
  const LazyComponent = lazy(importFunc);
  
  return (props) => (
    <Suspense fallback={
      <ContentLoader 
        loading={true} 
        message={loadingMessage} 
        minHeight={minHeight}
        size={size}
      />
    }>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default lazyLoad;
